export const API_URL = "https://api.bigeron.com/api/v1";
export const IMG_URL = "https://img.bigeron.com/"

export const getURL = () => {
    return {
        API_URL,
        IMG_URL,
    }
};



// WEBPACK FOOTER //
// ./src/api/index.js